// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3bWAK","form":"styles_form__19O92","info":"styles_info__1SrqY","submit":"styles_submit__3wq7j"};